/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_AddInputs */

const en_session_add = /** @type {(inputs: Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add cook session`)
};

const de_session_add = /** @type {(inputs: Session_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kochsession anlegen`)
};

/**
* | output |
* | --- |
* | "Add cook session" |
*
* @param {Session_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_add = /** @type {((inputs?: Session_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_add(inputs)
	return en_session_add(inputs)
});